import React, { useEffect } from 'react';

import './profile.scss';
import { Loader, ProfileForm } from '../../components';
import { connect } from 'react-redux';
import { parseDate } from '../../utils/helper';
import {
  answerProfile,
  getProfileQuestion,
} from '../../redux/actions/AuthenticationAction';

const Profile = ({
  userInfo: {
    email,
    first_name,
    last_name,
    dob,
    company_anniversary,
    personal_email = {},
  },
  getProfileQuestion,
  profileQuestion: { loading, questions },
}) => {
  const details = {
    email,
    firstName: first_name || '',
    lastName: last_name || '',
    personalEmail: personal_email || '',
    birthDate: '',
    companyAnniversary: '',
  };

  useEffect(() => {
    getProfileQuestion();
  }, []);

  if (dob) {
    details.birthDate = parseDate(dob);
  }

  if (company_anniversary) {
    details.companyAnniversary = parseDate(company_anniversary);
  }

  if (loading) return <Loader />;

  return (
    <div className="w-100 d-flex justify-content-center">
      <div className="profile-update-wrapper">
        <div className="profile-title">About Me</div>
        <ProfileForm
          details={details}
          questions={questions}
          answerProfile={answerProfile}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userInfo: state.auth.userInfo.info,
  profileQuestion: state.auth.profileQuestion || {},
});

const mapDispatchToProps = (dispatch) => ({
  getProfileQuestion: () => {
    dispatch(getProfileQuestion());
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(Profile);
